export default {
  circleStatic: {
    strokeLinecap: "round" as const
  }
};
